import React from "react";

function useOutsideAlerter(ref, setX) {
    React.useEffect(() => {

        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setX(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, setX]);
}

const MenuDropdown = (props) => {
    const {button, children, classNames, mainClassName, animation} = props;
    const wrapperRef = React.useRef(null);
    const [openWrapper, setOpenWrapper] = React.useState(false);
    useOutsideAlerter(wrapperRef, setOpenWrapper);

    return (
        <div ref={wrapperRef} className={`relative flex ${mainClassName}`}>
            <div className="flex " onMouseDown={() => setOpenWrapper(!openWrapper)}>
                {button}
            </div>
            <div
                // onMouseDown={() => setOpenWrapper(!openWrapper)}
                className={`${classNames} absolute z-10 ${
                    animation
                        ? animation
                        : "origin-top-right transition-all duration-300 ease-in-out"
                } ${openWrapper ? "scale-100" : "scale-0"}`}
            >
                {children}
            </div>
        </div>
    );
};

export default MenuDropdown;
